import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    /* CustomerStatuses */

    // Получение списка статусов заказчика
    async getCustomerStatuses(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`customer_statuses?${params.toString()}${sorting}`);
    },
    // Получение статуса заказчика по id
    async getCustomerStatusById(id) {
      return await this.get(`customer_statuses/id/${id}`);
    },
    // Создание статуса заказчика
    async postCustomerStatus(data) {
      return await this.post('customer_statuses', data);
    },
    // Изменение статуса заказчика
    async putCustomerStatus(data) {
      return await this.put(`customer_statuses/id/${data.id}`, data);
    },
    // Получение статусов заказчика по запросу
    async getCustomerStatusesSearch(query) {
      return await this.get(`customer_statuses/search?query=${query}`);
    },

    /* Departments */

    async getDepartments(data) {
      let params = this.makeSearchParams(data);
      return await this.get(`departments?${params.toString()}`);
    },
    async getDepartmentById(id) {
      return await this.get(`departments/${id}`);
    },
    async postDepartment(data) {
      return await this.post('departments', data);
    },
    async putDepartment(data) {
      return await this.put(`departments/${data.id}`, data);
    },
    async getDepartmentSearch(query) {
      return await this.get(`departments/search?query=${query}`);
    },

    /* JobTitles */

    async getJobTitles(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`job_titles?${params.toString()}${sorting}`);
    },
    async getJobTitleById(id) {
      return await this.get(`job_titles/${id}`);
    },
    async postJobTitle(data) {
      return await this.post('job_titles', data);
    },
    async putJobTitle(data) {
      return await this.put(`job_titles/${data.id}`, data);
    },
    async getJobTitlesSearch(query) {
      return await this.get(`job_titles/search?query=${query}`);
    },

    /* LeadSources */

    async getLeadSources(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`lead_sources?${params.toString()}${sorting}`);
    },
    async getLeadSourceById(id) {
      return await this.get(`lead_sources/id/${id}`);
    },
    async postLeadSource(data) {
      return await this.post('lead_sources', data);
    },
    async putLeadSource(data) {
      return await this.put(`lead_sources/id/${data.id}`, data);
    },
    async getLeadSourcesSearch(query) {
      return await this.get(`lead_sources/search?query=${query}`);
    },

    /* LeadStatuses */

    async getLeadStatuses(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`lead_statuses?${params.toString()}${sorting}`);
    },
    async getLeadStatusById(id) {
      return await this.get(`lead_statuses/id/${id}`);
    },
    async postLeadStatus(data) {
      return await this.post('lead_statuses', data);
    },
    async putLeadStatus(data) {
      return await this.put(`lead_statuses/id/${data.id}`, data);
    },
    async getLeadStatusesSearch(query) {
      return await this.get(`lead_statuses/search?query=${query}`);
    },

    /* LocationCostTypes */

    // Получение списка расходов объекта
    async getLocationCostTypes(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`location_cost_types?${params.toString()}${sorting}`);
    },
    async getLocationCostTypeById(id) {
      return await this.get(`location_cost_types/${id}`);
    },
    async postLocationCostType(data) {
      return await this.post(`location_cost_types`, data);
    },
    async putLocationCostType(data) {
      return await this.put(`location_cost_types/${data.id}`, data);
    },
    async getLocationCostTypesSearch(query) {
      return await this.get(`location_cost_types/search?query=${query}`);
    },

    /* LocationStatuses */

    async getLocationStatuses(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`location_statuses?${params.toString()}${sorting}`);
    },
    async getLocationStatusById(id) {
      return await this.get(`location_statuses/id/${id}`);
    },
    async postLocationStatus(data) {
      return await this.post(`location_statuses`, data);
    },
    async putLocationStatus(data) {
      return await this.put(`location_statuses/id/${data.id}`, data);
    },
    async getLocationStatusesSearch(query) {
      return await this.get(`location_statuses/search?query=${query}`);
    },

    /* MarketingSources */

    async getMarketingSources(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`marketing_sources?${params.toString()}${sorting}`);
    },
    async getMarketingSourceById(id) {
      return await this.get(`marketing_sources/id/${id}`);
    },
    async postMarketingSource(data) {
      return await this.post('marketing_sources', data);
    },
    async putMarketingSource(data) {
      return await this.put(`marketing_sources/${data.id}`, data);
    },

    /* ProjectStatuses */

    async getProjectStatuses(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`project_statuses?${params.toString()}${sorting}`);
    },
    async getProjectStatusById(id) {
      return await this.get(`project_statuses/id/${id}`);
    },
    async postProjectStatus(data) {
      return await this.post(`project_statuses`, data);
    },
    async putProjectStatus(data) {
      return await this.put(`project_statuses/id/${data.id}`, data);
    },
    async getProjectStatusesSearch(query) {
      return await this.get(`project_statuses/search?query=${query}`);
    },

    /* TaskGroups */

    async getTaskGroups(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`task_groups?${params.toString()}${sorting}`);
    },
    async getTaskGroupById(id) {
      return await this.get(`task_groups/id/${id}`);
    },
    async postTaskGroup(data) {
      return await this.post(`task_groups`, data);
    },
    async putTaskGroup(data) {
      return await this.put(`task_groups/id/${data.id}`, data);
    },
    async getTaskGroupsSearch(query) {
      return await this.get(`task_groups/search?query=${query}`);
    },

    /* Towns */

    async getTowns(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`towns?${params.toString()}${sorting}`);
    },
    async getTownById(id) {
      return await this.get(`towns/id/${id}`);
    },
    async postTown(data) {
      return await this.post('towns', data);
    },
    async putTown(data) {
      return await this.put(`towns/${data.id}`, data);
    },

    /* Vacancies */

    async getVacancies(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`vacancies?${params.toString()}${sorting}`);
    },
    async getVacancyById(id) {
      return await this.get(`vacancies/${id}`);
    },
    async postVacancy(data) {
      return await this.post(`vacancies`, data);
    },
    async putVacancy(data) {
      return await this.put(`vacancies/${data.id}`, data);
    },
    async getVacancySearch(query) {
      return await this.get(`vacancies/search?query=${query}`);
    },

    /* WorkerCostTypes */

    async getWorkerCostTypes(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`worker_cost_types?${params.toString()}${sorting}`);
    },
    async getWorkerCostTypeById(id) {
      return await this.get(`worker_cost_types/${id}`);
    },
    async postWorkerCostType(data) {
      return await this.post(`worker_cost_types`, data);
    },
    async putWorkerCostType(data) {
      return await this.put(`worker_cost_types/${data.id}`, data);
    },
    async getWorkerCostTypesSearch(query) {
      return await this.get(`worker_cost_types/search?query=${query}`);
    },

    /* WorkerSources */

    async getWorkerSources(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`worker_sources?${params.toString()}${sorting}`);
    },
    async getWorkerSourceById(id) {
      return await this.get(`worker_sources/${id}`);
    },
    async postWorkerSource(data) {
      return await this.post('worker_sources', data);
    },
    async putWorkerSource(data) {
      return await this.put(`worker_sources/${data.id}`, data);
    },

    /* WorkServices */

    async getWorkServices(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`work_services?${params.toString()}${sorting}`);
    },
    async getWorkServiceById(id) {
      return await this.get(`work_services/${id}`);
    },
    async postWorkServices(data) {
      return await this.post(`work_services`, data);
    },
    async putWorkServices(data) {
      return await this.put(`work_services/${data.id}`, data);
    },
    async getWorkServicesSearch(data) {
      let params = this.makeSearchParams(data);
      return await this.get(`work_services/search?${params.toString()}`);
    },

    /* WorkType */

    async getWorkTypeCatalogs(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/work_type?${params.toString()}${sorting}`);
    },
    async getWorkTypeById(id) {
      return await this.get(`catalogs/work_type/id/${id}`);
    },
    async putWorkType(data) {
      return await this.put(`catalogs/work_type/${data.id}`, data);
    },
    async postWorkType(data) {
      return await this.post(`catalogs/work_type`, data);
    },
    // Получение видов работ по запросу
    async getWorkTypesSearch(data) {
      return await this.get(`catalogs/work_type/search?query=${data}`);
    },

    /* WorkerStatuses */

    async getWorkerStatuses(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`worker_statuses?${params.toString()}${sorting}`);
    },
    async getWorkerStatusById(id) {
      return await this.get(`worker_statuses/id/${id}`);
    },
    async postWorkerStatus(data) {
      return await this.post('worker_statuses', data);
    },
    async putWorkerStatus(data) {
      return await this.put(`worker_statuses/id/${data.id}`, data);
    },
    async getWorkerStatusesSearch(query) {
      return await this.get(`worker_statuses/search?query=${query}`);
    },

    /* RecruitResponseStatuses */

    async getRecruitResponseStatuses(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`recruit_response_statuses?${params.toString()}${sorting}`);
    },
    async getRecruitResponseStatusById(id) {
      return await this.get(`recruit_response_statuses/id/${id}`);
    },
    async postRecruitResponseStatus(data) {
      return await this.post('recruit_response_statuses', data);
    },
    async putRecruitResponseStatus(data) {
      return await this.put(`recruit_response_statuses/id/${data.id}`, data);
    },
    async getRecruitResponseStatusesSearch(query) {
      return await this.get(`recruit_response_statuses/search?query=${query}`);
    },

    /* RecruitTags */

    async getRecruitTags(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`recruit_tags?${params.toString()}${sorting}`);
    },
    async getRecruitTagById(id) {
      return await this.get(`recruit_tags/id/${id}`);
    },
    async postRecruitTag(data) {
      return await this.post('recruit_tags', data);
    },
    async putRecruitTag(data) {
      return await this.put(`recruit_tags/id/${data.id}`, data);
    },
    async getRecruitTagsSearch(query) {
      return await this.get(`recruit_tags/search?query=${query}`);
    },

    /* Citizenships */

    async getCitizenships(data) {
      let params = this.makeSearchParams(data);
      return await this.get(`citizenships?${params.toString()}`);
    },
    async getCitizenshipById(id) {
      return await this.get(`citizenships/id/${id}`);
    },
    async postCitizenship(data) {
      return await this.post('citizenships', data);
    },
    async putCitizenship(data) {
      return await this.put(`citizenships/id/${data.id}`, data);
    },
    async getCitizenshipsSearch(query) {
      return await this.get(`citizenships/search?query=${query}`);
    },

    /* DriverLicenseCategories */

    async getDriverLicenseCategories(data) {
      let params = this.makeSearchParams(data);
      return await this.get(`driver_license_categories?${params.toString()}`);
    },
    async getDriverLicenseCategoryById(id) {
      return await this.get(`driver_license_categories/id/${id}`);
    },
    async postDriverLicenseCategory(data) {
      return await this.post('driver_license_categories', data);
    },
    async putDriverLicenseCategory(data) {
      return await this.put(`driver_license_categories/id/${data.id}`, data);
    },
    async getDriverLicenseCategoriesSearch(query) {
      return await this.get(`driver_license_categories/search?query=${query}`);
    },

    /* EmploymentCategories */

    async getEmploymentCategories(data) {
      let params = this.makeSearchParams(data);
      return await this.get(`employment_categories?${params.toString()}`);
    },
    async getEmploymentCategoryById(id) {
      return await this.get(`employment_categories/id/${id}`);
    },
    async postEmploymentCategory(data) {
      return await this.post('employment_categories', data);
    },
    async putEmploymentCategory(data) {
      return await this.put(`employment_categories/id/${data.id}`, data);
    },
    async getEmploymentCategoriesSearch(query) {
      return await this.get(`employment_categories/search?query=${query}`);
    },

    /* JobPostingStatuses */

    async getJobPostingStatuses(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`job_postings/statuses?${params.toString()}${sorting}`);
    },
    async getJobPostingStatusById(id) {
      return await this.get(`job_postings/statuses/id/${id}`);
    },
    async postJobPostingStatus(data) {
      return await this.post(`job_postings/statuses`, data);
    },
    async putJobPostingStatus(data) {
      return await this.put(`job_postings/statuses/id/${data.id}`, data);
    },
    async getJobPostingStatusesSearch(query) {
      return await this.get(`job_postings/statuses/search?query=${query}`);
    },

    /* RecruitTasksStatuses */

    async getRecruitTaskStatuses(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`recruit_tasks/statuses?${params.toString()}${sorting}`);
    },
    async getRecruitTaskStatusById(id) {
      return await this.get(`recruit_tasks/statuses/id/${id}`);
    },
    async postRecruitTaskStatus(data) {
      return await this.post(`recruit_tasks/statuses`, data);
    },
    async putRecruitTaskStatus(data) {
      return await this.put(`recruit_tasks/statuses/id/${data.id}`, data);
    },
    async getRecruitTaskStatusesSearch(query) {
      return await this.get(`recruit_tasks/statuses/search?query=${query}`);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/catalogs.js